import { computePosition, autoUpdate, shift } from '@floating-ui/dom'

class TooltipComponent extends HTMLElement {
  constructor() {
    super()
    this.iconElement = document.createElement('div')
    this.contentElement = document.createElement('div')
    this.isInitialized = false
  }

  #mouseenterHandler = () => {
    if (document.activeElement.nodeName === 'SASAG-TOOLTIP' && document.activeElement !== this) {
      document.activeElement.blur()
    }

    this.show()
  }

  #mouseleaveHandler = () => {
    if (this.matches(':hover') || this.contentElement.matches(':hover')) return
    this.hide()
  }

  #contentMouseleaveHandler = () => {
    if (this.matches(':hover') || this.contentElement.matches(':hover')) return
    this.hide()
  }

  #focusHandler = () => {
    this.show()
  }

  #blurHandler = () => {
    this.hide()
  }

  connectedCallback() {
    // connectCallback seems to be called multiple times (maybe because of swiper?)
    if (!this.isInitialized) {
      this.isInitialized = true

      // Root element
      this.classList.add('sasag-tooltip')
      this.setAttribute('role', 'tooltip')
      this.setAttribute('tabindex', 0)

      // Move root elements children to content element
      const children = Array.from(this.children)
      children.forEach(child => {
        this.contentElement.appendChild(child)
      })
      this.contentElement.classList.add('sasag-tooltip-content')

      // Icon element
      this.iconElement.classList.add('tooltip-icon')
      this.appendChild(this.iconElement)
    }

    document.body.appendChild(this.contentElement)

    this.addEventListener('mouseenter', this.#mouseenterHandler)
    this.addEventListener('mouseleave', this.#mouseleaveHandler)
    this.contentElement.addEventListener('mouseleave', this.#contentMouseleaveHandler)
    this.addEventListener('focus', this.#focusHandler)
    this.addEventListener('blur', this.#blurHandler)
  }

  show() {
    if (this.cleanup) return

    this.cleanup = autoUpdate(this.iconElement, this.contentElement, () => {
      computePosition(this.iconElement, this.contentElement, {
        middleware: [shift({ padding: 8 })],
      }).then(({ x, y }) => {
        Object.assign(this.contentElement.style, {
          left: `${x}px`,
          top: `${y}px`,
        })
        this.iconElement.classList.add('active')
        this.contentElement.classList.add('active')
      })
    })
  }

  hide() {
    if (document.activeElement === this) return

    this.iconElement.classList.remove('active')
    this.contentElement.classList.remove('active')
    this.cleanup?.()
    this.cleanup = null
  }

  disconnectedCallback() {
    this.contentElement.remove()

    this.removeEventListener('mouseenter', this.#mouseenterHandler)
    this.removeEventListener('mouseleave', this.#mouseleaveHandler)
    this.contentElement.removeEventListener('mouseleave', this.#contentMouseleaveHandler)
    this.removeEventListener('focus', this.#focusHandler)
    this.removeEventListener('blur', this.#blurHandler)
  }
}

customElements.define('sasag-tooltip', TooltipComponent)
